import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const useStateWithQuery = <T>(
  initialState: T,
  queryName?: string
): [T, React.Dispatch<React.SetStateAction<T>>] => {
  const [state, setState] = useState(initialState);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (typeof state === 'object') {
      for (const [key, value] of Object.entries(
        state as T as { [key: string]: string }
      )) {
        searchParams.set(key, JSON.stringify(value ?? ''));
      }
    } else if (queryName) {
      searchParams.set(queryName, JSON.stringify(state ?? ''));
    }
    setSearchParams(searchParams, { replace: true });
  }, [state]);

  return [state, setState];
};

export default useStateWithQuery;
